import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeRoundDoor: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-round-door"><path d="M12.9592 3.23184C12.3767 2.85013 11.6233 2.85013 11.0408 3.23184L3.79082 7.98278C3.29732 8.30618 3 8.85648 3 9.4465V19.25C3 20.2165 3.7835 21 4.75 21H8.75C9.16421 21 9.5 20.6642 9.5 20.25V16.75C9.5 15.3693 10.6193 14.25 12 14.25C13.3807 14.25 14.5 15.3693 14.5 16.75V20.25C14.5 20.6642 14.8358 21 15.25 21H19.25C20.2165 21 21 20.2165 21 19.25V9.4465C21 8.85648 20.7027 8.30618 20.2092 7.98278L12.9592 3.23184Z" fill="currentColor"/></CentralIconBase>;
};

export default IconHomeRoundDoor;
